import React, { useLayoutEffect, useRef, useState } from "react";

interface PromotionTagsV3Props {
  primary?: string;
  others?: string[];
}

// "Promotions" chips above the V3 price table (#746): the tour's primary tag
// highlighted, then its other tags. Collapsed to two rows, with "Show All"
// only when the chips actually overflow.
const PromotionTagsV3: React.FC<PromotionTagsV3Props> = ({ primary, others = [] }) => {
  const listRef = useRef<HTMLDivElement>(null);
  const [expanded, setExpanded] = useState(false);
  const [overflowing, setOverflowing] = useState(false);
  const tagsKey = [primary, ...others].join("|");

  useLayoutEffect(() => setExpanded(false), [tagsKey]);

  // Re-measured on resize too: the list sits in a drawer that is hidden (and
  // zero-sized) until opened.
  useLayoutEffect(() => {
    const el = listRef.current;
    if (!el) return;

    const measure = () => setOverflowing(el.scrollHeight > el.clientHeight + 1);
    measure();
    const observer = new ResizeObserver(measure);
    observer.observe(el);
    return () => observer.disconnect();
  }, [tagsKey]);

  if (!primary && others.length === 0) return null;

  return (
    <div className="promotion-tags-v3">
      <div className="promotion-tags-v3_label">Promotions</div>
      <div ref={listRef} className={`promotion-tags-v3_list ${expanded ? "expanded" : ""}`}>
        {primary && <span className="promotion-tags-v3_tag primary">{primary}</span>}
        {others.map((tag) => (
          <span className="promotion-tags-v3_tag" key={tag}>{tag}</span>
        ))}
      </div>
      {overflowing && !expanded && (
        <button type="button" className="promotion-tags-v3_show-all" onClick={() => setExpanded(true)}>
          Show All
        </button>
      )}
    </div>
  );
};

export default PromotionTagsV3;
